import axios from "axios";
import Config from "../utils/Config";

class DocumentManagementAPI {
  config = {
    headers: {
      Authorization: "",
      GroupId: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, groupId, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.GroupId = groupId;
    this.config.headers.CompanyId = companyId;
  }

    //Upload Documents
    async uploadDocument(accessToken,formData) {
        this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
        const data = await axios.post(
          Config.BACKEND_URL + "/api/docMogu/upload", 
          formData,
          this.config
        );
        return data.data;
      }

    //download original Document
    async downloadOriginalDocument(accessToken,formData) {
      this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
  
      const response = await axios.get(
        Config.BACKEND_URL + `/api/docMogu/download/${formData.get("fileUrl")}`, 
        {
            headers: this.config.headers,
            responseType: 'blob'
        }
      );

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = formData.get("fileUrl").split('/').pop(); 
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }

    //download Documents In a zip
    async downloadOriginalDocumentZip(accessToken,formData) {
      this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
  
      const response = await axios.get(
        Config.BACKEND_URL + `/api/docMogu/download/${formData.get("fileUrl")}`, 
        {
            headers: this.config.headers,
            responseType: 'blob'
        }
      );

      return response;
    }

     //download Documents In a zip
    async downloadDocumentWithQRCodeZip(accessToken,formData) {
      this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
  
       const response = await axios.get(
        //Config.BACKEND_URL + `/api/docMogu/download-QR-pdf?MOGU_UUID=3KtPnVLdvHmwye1gJiNQc3&TPS_Id=ab87932c-00a8-4a85-ad06-33f5106b0359`, 
        Config.BACKEND_URL + `/api/docMogu/download-QR-pdf?MOGU_UUID=${formData.get("MOGU_UUID")}&TPS_Id=${formData.get("TPS_Id")}`, 
        {
            headers: this.config.headers,
            responseType: 'blob'
        }
      );

      return response;
    }

    //Delete invoice
    async deleteInvoice(accessToken,payload) {
      this.setAccessToken(accessToken, payload.groupId, payload.companyId);
      const data = await axios.patch(
        Config.BACKEND_URL + "/api/mogu/updateInvoiceActiveStatus", 
        payload,
        this.config
      );
      return data.data;
    } 

    //Delete Multiple Invoices
    async deleteMultipleInvoices(accessToken,payload) {
      this.setAccessToken(accessToken, payload.groupId, payload.companyId);
      const data = await axios.patch(
        Config.BACKEND_URL + "/api/docMogu/invoiceActiveStatusUpdate", 
        payload,
        this.config
      );
      return data.data;
    }

    //GET StatusTrail data
    async getStatusTrailData(accessToken,groupId, companyId,formData) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.get(
        Config.BACKEND_URL + `/api/docMogu/invoceStatusTrail?MOGU_UUID=${formData.get("MOGU_UUID")}&TPS_Id=${(formData.get("TPS_Id") !==null||formData.get("TPS_Id") !==undefined)? formData.get("TPS_Id") :""}`, 
        this.config
      );
      return data.data;
    } 

    //Cancel Document
    async cancelDocument(accessToken,groupId, companyId,payload) {
      console.log("API side cancellation payload",payload.length)
      this.setAccessToken(accessToken,groupId,companyId);
      const data = await axios.post(
        Config.BACKEND_URL + "/api/docMogu/cancelDocument", 
         payload,
         this.config
       );
      return data.data;
    } 

    //download PDF without QR
    async downloadPDF(accessToken,formData) {
      console.log("formData.get(MOGU_UUID)", formData.get("MOGU_UUID"))
      console.log("formData.get(TPS_Id)", formData.get("TPS_Id"))
      this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
      const response = await axios.get(
        Config.BACKEND_URL + `/api/docMogu/download-excel-pdf?MOGU_UUID=${formData.get("MOGU_UUID")}&TPS_Id=${formData.get("TPS_Id")}`, 
        {
            headers: this.config.headers,
            responseType: 'blob'
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${formData.get("MOGU_UUID")+Math.floor(Math.random() * 101)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }


    
    //download PDF with QR
    async downloadPDFWithQR(accessToken,formData) {
      console.log("formData.get(MOGU_UUID)", formData.get("MOGU_UUID"))
      console.log("formData.get(TPS_Id)", formData.get("TPS_Id"))
      this.setAccessToken(accessToken, formData.get("groupId"), formData.get("companyId"));
      const response = await axios.get(
        //Config.BACKEND_URL + `/api/docMogu/download-QR-pdf?MOGU_UUID=3KtPnVLdvHmwye1gJiNQc3&TPS_Id=ab87932c-00a8-4a85-ad06-33f5106b0359`, 
        Config.BACKEND_URL + `/api/docMogu/download-QR-pdf?MOGU_UUID=${formData.get("MOGU_UUID")}&TPS_Id=${formData.get("TPS_Id")}`, 
        {
            headers: this.config.headers,
            responseType: 'blob'
        }
      );

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${formData.get("MOGU_UUID")+Math.floor(Math.random() * 101)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }


    //GET View Data
    async GetViewData(accessToken,groupId,companyId,formData) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.get(
        Config.BACKEND_URL + `/api/docMogu/viewInvoiceSummery?MOGU_UUID=${formData.get("MOGU_UUID")}&TPS_Id=${formData.get("TPS_Id")}&groupId=${groupId}&companyId=${companyId}`, 
        this.config
      );
      //console.log('Return Data response',JSON.stringify(data.data));
      return data.data;
    }

    //Share Email
    async FileShareEmail(accessToken,payload) {
      this.setAccessToken(accessToken, payload.groupId, payload.companyId);
      const data = await axios.post(
        Config.BACKEND_URL + "/api/docMogu/invoiceShare", 
        payload,
        this.config
      );
      return data.data;
    }

};
export default new DocumentManagementAPI();